// Used to configure the general configuration of some components without modifying the components

import type { SorterResult } from '@mts/components/Table';
import { isArray } from '@mts-fe/utils';
import { PCMode } from '@mts/utils/env';

const getDataIndex = (dataIndex: string | string[]) =>
  isArray(dataIndex) ? dataIndex.join('.') : dataIndex.toString();

export default {
  // basic-table setting
  table: {
    // Form interface request general configuration
    // support xxx.xxx.xxx
    fetchSetting: {
      // The field name of the current page passed to the background
      pageField: 'page',
      // The number field name of each page displayed in the background
      sizeField: 'size',
      // Field name of the form data returned by the interface
      listField: 'data',
      // Total number of tables returned by the interface field name
      totalField: 'total',
    },
    // Number of pages that can be selected
    pageSizeOptions: ['25', '50', '100'],
    // Default display quantity on one page
    defaultPageSize: PCMode ? 100 : 25,
    // Default Size
    defaultSize: 'small',
    // Custom general sort function
    defaultSortFn: (sortInfo: SorterResult) => ({
      order:
        sortInfo.field && sortInfo.order
          ? { [getDataIndex(sortInfo.field)]: sortInfo.order === 'ascend' }
          : {},
    }),
    // Custom general filter function
    defaultFilterFn: (data: Partial<Recordable<string[]>>) => {
      return data;
    },
  },
};
